import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { XCircle, Home, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const PaymentErrorPage = () => {
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get('order');
  const error = searchParams.get('error');

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-lg">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-10 w-10 text-red-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-800 mb-2">Ödeme Başarısız</h1>
          <p className="text-slate-500 mb-6">
            {error || 'Ödeme işlemi sırasında bir hata oluştu.'}
          </p>
          
          {orderNumber && (
            <div className="bg-slate-100 rounded-lg p-4 mb-6">
              <p className="text-sm text-slate-500">Sipariş Numarası</p>
              <p className="font-mono font-bold text-slate-600">{orderNumber}</p>
            </div>
          )}
          
          <p className="text-slate-400 text-sm mb-6">
            Lütfen tekrar deneyin veya farklı bir ödeme yöntemi seçin.
          </p>
          
          <div className="flex gap-3">
            <Button asChild variant="outline" className="flex-1">
              <Link to="/">
                <Home className="h-4 w-4 mr-2" />
                Ana Sayfa
              </Link>
            </Button>
            <Button asChild className="flex-1 bg-orange-500 hover:bg-orange-600">
              <Link to="/misafir-alisveris">
                <RefreshCw className="h-4 w-4 mr-2" />
                Tekrar Dene
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentErrorPage;
